module.exports = __webpack_public_path__ + "img/sLuckyGems_193x205.e9936bf9.png";